(function () {
  function initYouTubeFacades(section) {
    section.querySelectorAll('.luxury-editorial__youtube-facade').forEach(function (trigger) {
      if (trigger.dataset.lesYoutubeBound === 'true') return;
      trigger.dataset.lesYoutubeBound = 'true';

      trigger.addEventListener('click', function () {
        var id = trigger.dataset.youtubeId;
        if (!id) return;

        var inner = trigger.closest('.luxury-editorial__media-inner');
        var card = trigger.closest('.luxury-editorial__card');
        if (!inner || !card) return;

        var iframe = document.createElement('iframe');
        iframe.className = 'luxury-editorial__youtube';
        iframe.src =
          'https://www.youtube.com/embed/' +
          id +
          '?autoplay=1&controls=1&rel=0&modestbranding=1&playsinline=1';
        iframe.title = trigger.getAttribute('aria-label') || 'YouTube video';
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('allowfullscreen', '');

        trigger.remove();
        inner.appendChild(iframe);
        card.classList.add('luxury-editorial__card--youtube-playing');
      });
    });
  }

  function initLuxuryEditorialShowcase(section) {
    if (!section || section.dataset.lesInitialized === 'true') return;
    section.dataset.lesInitialized = 'true';

    var videos = section.querySelectorAll('.luxury-editorial__media-inner video');

    if (videos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (!(video instanceof HTMLVideoElement)) return;

            if (entry.isIntersecting) {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2, rootMargin: '40px 0px' }
      );

      videos.forEach(function (video) {
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        observer.observe(video);
      });
    }

    initYouTubeFacades(section);
  }

  function boot() {
    document.querySelectorAll('[data-luxury-editorial]').forEach(initLuxuryEditorialShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-luxury-editorial]');
    if (section) {
      delete section.dataset.lesInitialized;
      initLuxuryEditorialShowcase(section);
    }
  });
})();
